import RenderHTML from '../../../../../ui-components/RenderHTML'
import { GROUPED_STATIC_TEXT_ROLE } from '../../../../../ui-components/NameValueTableRow'

export const BrokePowerRankPointer = ({ memberCount }: { memberCount: string }) => {
  return (
    <div className='flex flex-col'>
      <div className='flex flex-col gap-1'>
        <h3
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Power Rank'
          className='text-sm font-medium text-[#992E00] mb-1 m-0'
        >
          <span aria-hidden='true'>Power Rank</span>
        </h3>
        <h4
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Get expert guidance for new investments'
          className='text-base font-medium text-grey10 m-0'
        >
          <span aria-hidden='true'>Get expert guidance for new investments</span>
        </h4>
        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label='Choosing a new fund can feel confusing. Power Rank helps you select top-ranked funds easily, so you never have to guess.'
          className='text-sm text-grey40'
        >
          <span aria-hidden='true'>
            Choosing a new fund can feel confusing. Power Rank helps you select top-ranked funds easily, so you never
            have to guess.
          </span>
        </div>
        <div className='flex flex-row justify-center items-center my-5'>
          <img
            className='w-full h-auto'
            src='/images/elite/power_rank_elite.png'
            alt='Illustration representing fund ranking'
          />
        </div>
        <div
          role={GROUPED_STATIC_TEXT_ROLE}
          aria-label={`Most loved feature by our ${memberCount} Elite members`}
          className='bg-[#FFF2DF] flex flex-row justify-center items-center gap-2 px-6 py-2.5 rounded-xl'
        >
          <span aria-hidden='true'>
            <RenderHTML
              innerHTMLText={`<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12"><g clip-path="url(#a)"><path stroke="#992E00" stroke-width="1.4" d="M3.384 1.563c.638.047 1.365.366 2.115 1.115l.494.494.494-.493c.75-.746 1.48-1.063 2.12-1.109.722-.052 1.37.238 1.854.724.981.986 1.227 2.705.056 3.862l-4.524 4.188-4.521-4.186C.315 4.995.562 3.27 1.539 2.285c.481-.486 1.126-.775 1.845-.722Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>`}
            />
          </span>
          <span aria-hidden='true' className='text-xs text-[#992E00]'>
            Most loved feature by our {memberCount} Elite members
          </span>
        </div>
      </div>
    </div>
  )
}
